import LegalLayout from "@/components/LegalLayout";

const DOC = {
  title: "Delete Your NomNom Account",
  scope: "How to permanently delete your NomNom account and personal data · NomNom: AI Calorie Tracker · Nom Apps LLC",
  description:
    "Learn how to permanently delete your NomNom account and personal data, or contact Nom Apps LLC support. NomNom: AI Calorie Tracker by Nom Apps LLC.",
  sections: [
    {
      h: "Delete your account in the NomNom app",
      steps: [
        "Open NomNom and sign in to your account.",
        "Open Settings.",
        "Select the account deletion option.",
        "Follow the confirmation steps to permanently delete your account.",
      ],
    },
    {
      h: "If you cannot access your account",
      p: [
        "Contact support@nomappsllc.com and request deletion of your NomNom account. Send the request from the email address associated with your NomNom account so we can verify the request.",
      ],
    },
    {
      h: "What is deleted",
      p: [
        "When your NomNom account is deleted, Nom Apps LLC deletes or removes the personal data associated with the account from NomNom's systems, including account/profile information, food and nutrition logs, water logs, weight logs, exercise logs, mood check-ins, saved meals, progress and goal information, social information associated with the account, and uploaded meal photos/files associated with the account.",
        "Some limited information may be retained where required for legal, security, fraud-prevention, accounting, or regulatory purposes. Information independently maintained by third-party service providers may also be subject to those providers' retention requirements.",
      ],
    },
    {
      h: "Subscriptions",
      p: [
        "Deleting your NomNom account does not automatically cancel an active App Store or Google Play subscription. Users should cancel an active subscription through the applicable Apple App Store or Google Play subscription settings.",
      ],
    },
    {
      h: "Questions",
      p: ["Contact: support@nomappsllc.com", "Developer: Nom Apps LLC"],
    },
  ],
};

export default function DeleteAccount() {
  return <LegalLayout doc={DOC} testId="delete-account-page" />;
}
